module.exports = __webpack_public_path__ + "img/BEAR_SQUARE.8cf41a8f.jpg";